import { Events } from 'global/constants';

const { OdSelect } = window.od;

export default class SelectDeliveryDate {
	constructor(selectDeliveryDateElement) {
		this.deliveryDateSelect = selectDeliveryDateElement;
		this.hiddenDateInput = document.getElementById('deliveryDate');
		this.init();
	}

	init() {
		this.selectChoice = new OdSelect(this.deliveryDateSelect, {
			searchEnabled: false,
		});
		this.selectChoice.addEventListener(
			Events.CHOICES_CHOICE,
			this.datePicked.bind(this),
		);

		this.setDeliveryDate(this.deliveryDateSelect.value);
	}

	setDeliveryDate(date) {
		const deliveryDateValue = date;
		this.hiddenDateInput.setAttribute('value', deliveryDateValue);
	}

	datePicked(event) {
		const newDate = event.detail.choice.value;
		this.setDeliveryDate(newDate);
	}
}
